<template>
  <a-tabs v-model:activeKey="activeKey" @change="reloadData">
    <a-tab-pane key="1" tab="经营者">
      <OperatorPage ref="configPage"/>
    </a-tab-pane>
    <a-tab-pane key="2" tab="房源上报">
      <ConfigPage ref="configPage"/>
    </a-tab-pane>
    <a-tab-pane key="3" force-render tab="订单上报">
      <OrderPage/>
    </a-tab-pane>
    <a-tab-pane key="4" force-render tab="入住登记">
      <CheckinPage/>
    </a-tab-pane>
    <a-tab-pane key="5" tab="退房记录">
      <CheckoutPage/>
    </a-tab-pane>
    <a-tab-pane key="6" tab="开门记录">
      <OpenDoorPage/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import OperatorPage from './operator.vue';
import ConfigPage from './house.vue';
import CheckinPage from './checkIn.vue';
import CheckoutPage from './checkOut.vue';
import OpenDoorPage from './openDoor.vue';
import OrderPage from './order.vue';

import {ref} from 'vue';
// eslint-disable-next-line no-unused-vars
const activeKey = ref('1');
export default {
  components: {
    OperatorPage, CheckinPage, ConfigPage, CheckoutPage, OpenDoorPage, OrderPage
  },
  data() {
    return {
      activeKey: '1' // 设置默认的activeKey
    }
  },
  methods: {
    reloadData(key) {
      // 在这里编写重新加载数据的逻辑
      console.log(key)
      if (key == 1) {
        // this.$refs.configPage.table.getTableData();
      }
    }
  }
};
</script>
<style>
</style>

